import type { AppType } from '../types/app'
import packageJson from '../../../package.json'

export const appInitialValues: AppType = {
  version: packageJson.version,
  locale: 'en-US',
  alpha2: 'US',
  alpha3: 'usa',
  language: 'en',
  flashSaleAppeared: false,
  isCartOpen: false,
  isLoading: false,
  marketExceptions: null,
  translations: {},
  isSearchBarActive: false,
  isMobileDrawerOpen: false,
  searchBarValue: '',
  globalLoaders: {
    savingShippingAddress: false,
  },
  addProductToSubscription: {
    userHasActiveSubscription: false,
    isSelectActiveSubscriptionModalOpen: false,
    isConfirmAddToActiveSubscriptionModalOpen: false,
    selectedSubscriptionId: null,
    selectedSubscriptionIndex: null,
  },
  geoIp: {
    zipCode: null,
    city: null,
    region: null,
    latitude: null,
    longitude: null,
  },
  isLoginPopoverOpen: false,
  launchDarklyDynamicContext: {
    selectedPaymentMethod: null,
  },
}
